<template>
  <div class="pe-site-plan-design-grade-pick-confirm">
    <div v-if="rowSelected"
         class="input">
      <el-select v-model="form.flagExamStyle"
                 size="mini"
                 placeholder="请选择考核方式"
                 loading-text="加载中..."
                 :loading="loading"
                 @visible-change="loadFlagExamStyles">
        <template v-if="flagExamStyles">
          <el-option v-for="flagExamStyle in flagExamStyles"
                     :key="flagExamStyle.id"
                     :label="flagExamStyle.name"
                     :value="flagExamStyle.code"></el-option>
        </template>
      </el-select>
    </div>
    <div class="extra">
      <el-button class="grid-menu-item"
                 type="primary"
                 :loading="committing"
                 :disabled="!rowSelected"
                 @click="handleApply">{{committing ? '添加中...' : '点击添加'}}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PeSitePlanDesignGradePickConfirm',
  inject: ['$menu'],
  props: {
    gridData: {
      type: Object,
      required: true
    },
    preHandleParams: {
      type: Function,
      required: true
    },
    extraParams: Object
  },
  data () {
    return {
      loading: false,
      flagExamStyles: null,
      form: {
        flagExamStyle: ''
      },
      committing: false
    }
  },
  computed: {
    rowSelected () {
      let rowSelection = this.gridData.rowSelection
      if (rowSelection) {
        return !!rowSelection.length
      }
    }
  },
  methods: {
    loadFlagExamStyles (popperVisible) {
      if (popperVisible && !this.loading && !this.flagExamStyles) {
        this.loading = true
        this.$ajax({
          url: '/workspace/manager/portal/data/select/flagExamStyles',
          method: 'post'
        }).then(response => {
          if (response.data) {
            this.flagExamStyles = response.data['flagExamStyles'] || []
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.loading = false
        })
      }
    },
    handleApply () {
      if (!this.form.flagExamStyle) {
        this.$message.warning('请选择考核方式')
        return
      }
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/basic/peSite/plan/course/add',
        method: 'post',
        data: this.$qs.stringify(this.$extend(this.preHandleParams(), this.form, this.extraParams), {
          arrayFormat: 'repeat'
        })
      }).then(response => {
        switch (response.data['responseCode']) {
          case 'SUCCESS': {
            this.$message.success(response.data['message'])
            this.$nextTick(() => {
              this.$emit('reloadGridData')
              this.$menu.triggerDataChange('add')
            })
            break
          }
          default: {
            this.$message.warning(response.data['message'])
            break
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    }
  },
  watch: {
    rowSelected (val) {
      if (!val) {
        Object.keys(this.form).forEach(key => {
          this.form[key] = ''
        })
      }
    }
  }
}
</script>

<style lang="scss">
  .pe-site-plan-design-grade-pick-confirm {
    display: flex;
    align-items: center;
    & > .input {
      margin-right: 5px;
      .el-select {
        width: 140px;
      }
    }
  }
</style>
